import type { RecipeV2Doc } from '@ctcells/api'

import { isNewFormatRecipe } from '../recipes/recipeStandardModel.ts'

/**
 * 레시피 본문 → 새 형식 문서(요약 · 상세 팝업이 읽는 꼴). 옛 형식이면 `undefined` — 요약을 묻지 않는다.
 * 작업 추가 창(`BatchNewContainer`)과 작업 상세(`BatchDetailContainer`)의 [상세] 팝업이 같이 쓴다.
 */
export function newFormatDoc(payload: unknown): RecipeV2Doc | undefined {
  if (!isNewFormatRecipe(payload)) return undefined
  return payload as RecipeV2Doc
}
